import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createPickupLocationVehicleAsync, updatePickupLocationVehicleAsync, getVehiclesByPickupLocationIdAsync, getAllVehiclesByPickupLocationIdAsync, getVehicleByIdAsync, deletePickupLocationVehicleAsync } from './pickupLocationVehicleThunk';
const initialState = {
    status: APIStatus.IDLE,
    vehicle: undefined,
    vehicles: undefined,
    paginatedVehicles: undefined
};
export const pickupLocationVehicleSlice = createSlice({
    name: 'pickupLocationVehicle',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createPickupLocationVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createPickupLocationVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehicle = action.payload;
        })
            .addCase(createPickupLocationVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updatePickupLocationVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePickupLocationVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                state.vehicle = action.payload.data;
            }
        })
            .addCase(updatePickupLocationVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getVehiclesByPickupLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getVehiclesByPickupLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedVehicles = action.payload;
        })
            .addCase(getVehiclesByPickupLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllVehiclesByPickupLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllVehiclesByPickupLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehicles = action.payload;
        })
            .addCase(getAllVehiclesByPickupLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getVehicleByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getVehicleByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehicle = action.payload;
        })
            .addCase(getVehicleByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deletePickupLocationVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deletePickupLocationVehicleAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deletePickupLocationVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default pickupLocationVehicleSlice.reducer;
